import Vue from "vue";
import {appendToUrl} from "../../search/urlUtils";
import {getFixedValue, convertUnits} from "../../utilities/unitsHelper";
import {isMobile, setInputFilter, isIOS} from "../../utilities/globalUtilities";
import {
    updatedQuantityCallback,
    updateProductQtyMap,
    triggerCartUpdate,
    triggerProductRemoval,
    updateCartPriceInformation,
    startSpinner,
    stopSpinner,
    updateCartSummary,
    updateCouponsSummary,
    blurQtyInput,
    getGTMData
} from "../../components/cartUtil";
import {getClosestMaxAllocation} from "../../utilities/unitsHelper";
import {setMaxNumberOfUnitsPerSale} from "../../components/quantityHelper";
import debounce from "lodash/debounce";

const regex = require("../../utilities/regex");

/**
 * Input Quantity Vue Component
 */
const QuantityComponent = Vue.extend({
    data: function () {
        return {
            debounceUpdateQuantity: null
        };
    },
    methods: {
        /**
         * Prepares to update the product's quantity
         * @param {object} ev - the event that triggered the function
         */
        updateQuantity(ev) {
            const productUUID = this.$store.getters.getProductInfo(this.pid, "UUID");
            const previousUnits = this.createProductUnitsConversion();
            const inputName = `quantityInput-${this.pid}${this.additionalTag}`;
            const $minicartItem = $(ev.target).closest(".ct-tile-quantity.minicart");
            const $cartItem = $(ev.target).closest(".ct-tile-quantity.cart-tile");
            const $standardItem = $(ev.target).closest(".ct-tile-quantity.tile, .ct-tile-quantity.pdp-qty-tile");
            let canRemove = false;
            let originalInsertedValue = null;

            if (ev.target.classList.contains("increase-quantity-btn")) {
                this.prodUnits.addStep();
            } else if (ev.target.classList.contains("decrease-quantity-btn")) {
                var minQuantity = this.prodUnits.selectedUnit == this.prodUnits.primaryUnit ? this.prodUnits.minQty : convertUnits(this.prodUnits.minQty, this.prodUnits.selectedUnit, this.prodUnits.conversionRate, this.prodUnits.units.multiplier);
                var quantityValue = getFixedValue(this.$refs[inputName].value, this.prodUnits.selectedUnit);

                // trigger click on trash icon to display Anular block
                if (minQuantity == quantityValue) {
                    if ($minicartItem && $minicartItem.length) {
                        $minicartItem.closest(".minicart-product-line").find(`.minicart-remove-product[data-pid="${this.pid}"]`).first(0).trigger("click");
                        return;
                    }

                    if ($cartItem && $cartItem.length) {
                        $cartItem.closest(".ct-cart-tile").find(`.remove-product[data-pid="${this.pid}"]`).first(0).trigger("click");
                        return;
                    }
                }

                this.prodUnits.subtractStep();

                canRemove = true;
            } else {
                let newValue = getFixedValue(this.$refs[inputName].value, this.prodUnits.selectedUnit);
                const inputValue = parseFloat(this.$refs[inputName].value);
                originalInsertedValue = newValue;

                if (inputValue != 0 && inputValue < this.prodUnits.minQty) {
                    this.canDisplayMinQtyErrorMsg = true;
                    this.isMinQtyReached = true;
                    this.prodUnits.syncFlag = {pid: this.pid};
                }

                if (!isNaN(newValue)) {
                    var previousQuantityValue = this.prodUnits.getValue();

                    if (newValue <= 0 && (($minicartItem && $minicartItem.length) || ($cartItem && $cartItem.length))) {
                        newValue = previousQuantityValue;
                    }

                    this.prodUnits.updateValue(newValue, this.prodUnits.selectedUnit);
                    canRemove = newValue == 0;

                    blurQtyInput(ev.target);

                    // If is a mobile, trigger blur to avoid input value not being sync
                    if (isMobile()) {
                        this.$refs[inputName].blur();
                    }
                } else {
                    this.displayValue = this.prodUnits.getFormattedValue();

                    return;
                }
            }

            this.displayValue = this.prodUnits.getFormattedValue();

            if (this.prodUnits.getValue() >= this.prodUnits.minQty && this.prodUnits.getValue() != previousUnits.getValue()) {
                if (originalInsertedValue != 0) {
                    this.debounceUpdateQuantity(productUUID, previousUnits, ev.target);
                }
            } else if (this.prodUnits.getValue() < this.prodUnits.minQty) {
                if (canRemove) {
                    this.prodUnits.syncFlag = {pid: this.pid, remove: true};
                    this.prodUnits = null;
                    this.canDisplayMinQtyErrorMsg = false;

                    // trigger click on trash icon to display Anular block
                    if (originalInsertedValue == 0 && $cartItem && $cartItem.length) {
                        $cartItem.closest(".ct-cart-tile").find(`.remove-product[data-pid="${this.pid}"]`).first(0).trigger("click");
                        return;
                    }

                    triggerProductRemoval(this.pid, productUUID);

                    this.debounceUpdateQuantity.cancel();
                } else {
                    this.debounceUpdateQuantity(productUUID, previousUnits, ev.target);
                }
            }

            // trigger click on trash icon to display Anular block
            if (originalInsertedValue == 0 && ($minicartItem?.length || $cartItem?.length || $standardItem?.length)) {
                if ($minicartItem && $minicartItem.length) {
                    $minicartItem.closest(".minicart-product-line").find(`.minicart-remove-product[data-pid="${this.pid}"]`).first(0).trigger("click");
                } else if ($standardItem?.length) {
                    triggerProductRemoval($standardItem.closest(`.ct-tile-quantity[data-pid="${this.pid}"]`).data("pid"), productUUID);
                } else {
                    $cartItem.closest(".ct-cart-tile").find(`.remove-product[data-pid="${this.pid}"]`).first(0).trigger("click");
                }
            }
        },
        updateQtyFormat(ev) {
            // remove selected unit
            ev.target.value = ev.target.value.slice(0, -(this.prodUnits.selectedUnit.length + 1));

            if ($(".minicart").hasClass("is-open") && isMobile() && !isIOS()) {
                $(".minicart-products-container").addClass("minicart-products-container--scrolled");
                setTimeout(() => ev.target.scrollIntoView(), 200);
            }
        },
        restoreQtyFormat(ev) {
            // add selected unit
            ev.target.value = ev.target.value.replace(regex.values.nonDigit, "") + " " + this.prodUnits.selectedUnit;
            $(".minicart-products-container").removeClass("minicart-products-container--scrolled");
        },
        setDimension(ev) {
            if (ev.target.classList.contains("pwc-form-check-input")) {
                const urlParams = {
                    pid: this.pid,
                    dimension: ev.target.value,
                };
                const dimensionUpdateUrl = appendToUrl(this.$store.state.dimensionUpdateUrl, urlParams);

                fetch(dimensionUpdateUrl)
                    .then(response => response.json())
                    .then(data => {
                        updateProductQtyMap(JSON.parse(data.productQtyMap) || {}, ev.target);
                        triggerCartUpdate();
                    });
            }
        },
        /**
         * Handles the product's quantity updates
         * @param {object} productUUID - the product's UUID
         * @param {object} previousUnits - the previous units to be used in case of error
         * @param {object} target - the target element
         */
        handleQuantityUpdate(productUUID, previousUnits, target) {
            const $gtmList = target.closest(".gtm-list");
            const list = $gtmList ? $gtmList.getAttribute("data-gtm-list") : null;
            var {gtmIndex, gtmList} = getGTMData($(target), list);

            const urlParams = {
                pid: this.pid,
                quantity: this.prodUnits.getValue(),
                step: this.prodUnits.step,
                uuid: productUUID,
                dimension: this.prodUnits.selectedUnit,
                isCart: $(".js-cart-page").length > 0,
                gtmList: gtmList,
                gtmIndex: gtmIndex
            };

            const newUrl = appendToUrl(this.$store.state.updateUrl, urlParams);

            startSpinner();

            const that = this;
            fetch(newUrl)
                .then(response => response.json())
                .then(data => {
                    //Updates product information for cart page
                    updateCartPriceInformation(productUUID, data);

                    if (data.responseJSON && data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        // basket may contain unavailable products from Ipaper (not in site catalog) or product which becomes offline.
                        // condition is needed in order to keep ability for other products qty change
                        // Updates the minQty/maxQty
                        if (data.finalQuantity >= that.prodUnits.maxQty || data.availableToSell < that.prodUnits.maxQty) {
                            let qtyToSet = (data.finalQuantity == that.prodUnits.maxQty && data.finalQuantity < data.availableToSell) ? data.finalQuantity : data.availableToSell;
                            let maxNumberOfUnitsPerSale = getClosestMaxAllocation(qtyToSet, that.prodUnits.step);
                            setMaxNumberOfUnitsPerSale(this.pid, maxNumberOfUnitsPerSale);

                            that.maxQtyToDisplay = maxNumberOfUnitsPerSale;
                        }

                        if (data.finalQuantity <= that.prodUnits.minQty) {
                            that.minQtyToDisplay = data.finalQuantity;
                            that.canDisplayMinQtyErrorMsg = true;
                        }

                        updatedQuantityCallback(data, target);
                        updateCartSummary(data);
                        updateCouponsSummary(data);
                    }

                    //code necessary for GTM - start
                    const eventObj = {
                        detail: {
                            "dataLayerObject": data.dataLayerObject
                        }
                    };

                    if (data.quantityChange?.isIncreased) {
                        document.dispatchEvent(new CustomEvent("dataLayer.addToCart", eventObj));
                    } else {
                        document.dispatchEvent(new CustomEvent("dataLayer.removeFromCart", eventObj));
                    }
                    //code necessary for GTM - end

                    blurQtyInput(target);
                    stopSpinner();
                });
        }
    },

    /**
     * When mounted, prepares the debounce update quantity functionality
     */
    mounted() {
        this.debounceUpdateQuantity = debounce(this.handleQuantityUpdate, this.$store.state.delayTime);
        const inputName = `quantityInput-${this.pid}${this.additionalTag}`;

        setInputFilter(this.$refs[inputName], value => { return regex.values.floatValue.test(value); });
    }
});

export default QuantityComponent;
